import { Button, ErrorView, Heading1, Paragraph2, theme } from 'inpock-ui-react';

export function NotFound404() {
  const goToKakao = () => {
    window.open('https://inpocklink.channel.io/home');
  };

  return (
    <ErrorView
      emojii="😱"
      header={
        <Heading1>
          페이지를&nbsp;
          <span style={{ color: theme.colors.error }}>찾을 수 없습니다</span>
        </Heading1>
      }
      description={
        <Paragraph2>
          접속을 원하는 페이지의 주소가 없습니다
          <br />
          주소가 정확한지 다시 한 번 확인해주세요
        </Paragraph2>
      }
      cta={
        <>
          <Button size="large" type="primary" fullWidth onClick={goToKakao}>
            인포크 팀에게 오류 알려주기
          </Button>
          {/* <Button size="large" type="secondary" fullWidth onClick={onClickHome}>
            인포크링크 비즈니스 홈페이지
          </Button> */}
          <Button size="large" type="secondary" fullWidth onClick={() => window.history.back()}>
            뒤로가기
          </Button>
        </>
      }
    />
  );
}
